import React from "react";
import { IconButton as Base, IconButtonProps } from "@chakra-ui/core";
import { Tooltip } from './'

type OwnProps = {
  tooltipLabel?: React.ReactNode
}

const withToolTip = (wrappedElement: React.ReactElement, tooltipLabel: React.ReactNode): React.ReactElement => (
  // @ts-ignore - even though chakra ui type is only string, it actually accepts React.ReactNode
  // refer to https://github.com/chakra-ui/chakra-ui/issues/2448
  // might be fixed in a future chakra ui release
  <Tooltip label={tooltipLabel} hasArrow>{wrappedElement}</Tooltip>
)

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps & OwnProps>((
  { tooltipLabel, ...props }, ref
) => {
  const wrappable = <Base ref={ref} {...props}/>;

  return tooltipLabel ? withToolTip(wrappable, tooltipLabel) : wrappable
});

export default IconButton;

